import { withDefault, StringParam } from 'use-query-params';
import { CustomStringParam, SchemaFilterType, SortDir } from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Date created',
    sortable: false,
  },
  {
    name: 'baseellaStatus',
    label: 'Status',
    sortable: false,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: false,
  },
  {
    name: 'sum',
    label: 'Amount',
    sortable: false,
  },
  {
    name: 'documentNumber',
    label: 'Doc #',
    sortable: false,
  },
];

export const columnsLabels = {};

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sum: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  documentNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};
